// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BodyNameCell__gender-img{margin-right:4px}", "",{"version":3,"sources":["webpack://./src/main/js/common/components/body-name-cell/body-name-cell.styles.scss"],"names":[],"mappings":"AAGE,0BACE,gBAAA","sourcesContent":["@import '~@common/styles/variables.scss';\n\n.BodyNameCell {\n  &__gender-img {\n    margin-right: 4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
